module.exports = __webpack_public_path__ + "static/media/supply.77db1410.jpg";